import { type AxiosPromise } from "axios"
import { type ILogin_Request } from "../../../../interfaces/ILogin"
import httpModule from "../../../../utils/http"

const API_URL = process.env.REACT_APP_API_URL
console.log(API_URL)

export const postLogin = async ({ usuario, clave }: ILogin_Request): Promise<AxiosPromise<any>> =>
  await httpModule.post(`${API_URL}/api/backoffice/v1/usuarios/login`, { usuario, clave })

export const postLoginForgot = async ({ usuario }: ILogin_Request): Promise<AxiosPromise<any>> =>
  await httpModule.get(`${API_URL}/api/mobile/v1/usuarios/recuperarclave/${usuario}`)

export const postLoginChange = async (nuevaClave): Promise<AxiosPromise<any>> =>
  await httpModule.patch(`${API_URL}/api/mobile/v1/usuarios/cambiarclave`, nuevaClave)
